import { forwardRef, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input, type InputProps } from './input.tsx';

export interface PasswordInputProps extends Omit<InputProps, 'type' | 'suffix'> {
  toggleAriaLabelShow?: string;
  toggleAriaLabelHide?: string;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ toggleAriaLabelShow, toggleAriaLabelHide, ...props }, ref) => {
    const [isVisible, setIsVisible] = useState(false);

    const ariaLabel = isVisible
      ? (toggleAriaLabelHide ?? 'Masquer le mot de passe')
      : (toggleAriaLabelShow ?? 'Afficher le mot de passe');

    return (
      <Input
        ref={ref}
        type={isVisible ? 'text' : 'password'}
        suffix={
          <button
            type="button"
            aria-label={ariaLabel}
            onClick={() => setIsVisible((v) => !v)}
            className="inline-flex justify-center items-center w-4 h-4 hover:text-foreground focus-visible:outline-none"
          >
            {isVisible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
          </button>
        }
        {...props}
      />
    );
  }
);

PasswordInput.displayName = 'PasswordInput';
